import type { Ref } from "react";
import { ScrollArea } from "@/core/components/ui/scroll-area";
import { Stack } from "@/core/components/ui/stack";
import { StatementRenderer } from "@/payroll/ai-script/statement/statement-renderer";
import type { ComparisonStatementSide } from "./types";
export const StatementPane = ({
  heading,
  side,
  viewportRef,
}: {
  heading: string;
  side: ComparisonStatementSide | undefined;
  /** Driven by the other side, so both show the same part of the document. */
  viewportRef: Ref<HTMLDivElement>;
}) => (
  <Stack
    gap="none"
    align="stretch"
    direction="column"
    className="flex min-h-0 min-w-0 flex-col"
  >
    <p className="border-b border-stroke-tertiary px-3 py-1 text-sm font-semibold uppercase tracking-wide text-secondary-text">
      {heading}
    </p>
    {side?.issues.length ? (
      <div className="p-4 text-sm" role="alert">
        <p className="font-medium">This PayPack does not render.</p>
        <p className="mt-1 text-secondary-text">{side.issues.join(" ")}</p>
      </div>
    ) : (
      <ScrollArea vertical viewportRef={viewportRef} className="min-h-0 flex-1">
        {/* The rail and this pane's own heading already say whose statement
            this is; the renderer's title would be a third copy. */}
        {side && (
          <StatementRenderer statement={side.statement} showTitle={false} />
        )}
      </ScrollArea>
    )}
  </Stack>
);
